const reportDB = require("../../../../../components/report/report-db");
const report = require("../../../../../components/report/report");
const style = require("../../../../../components/report/report-style");
const css = style.get();
const page = require("../../../../../components/page/page");
const math = require("../../../../../js-handler/math");
import { createChart } from "./chart/customerProfit-page-chart";


export function fetchAll(detail, callback) {
  const phpFile = "server/php/sql/report.php";
  detail.inf = { entity: detail.dest.entidad, report: "account-all-profit" };
  if (detail.sort) {
    detail.inf.sort_by = detail.sort.by;
    detail.inf.sort_dir = detail.sort.dir;
  }

  if (detail.search) {
    detail.inf.searchReceivable = detail.search;
  }

  reportDB.select(detail, phpFile, (data) => {
    callback(data);
    createChart(data);
    const pageTarget = document.getElementById("customerProfit-page-right");
const dataContainer = pageTarget.querySelector('.dataContReceivable');

// Limpia solo la data dinámica
if (dataContainer) {
  dataContainer.innerHTML = '';
}

// Generar nuevo contenido
const body = generate(data);
dataContainer.insertAdjacentHTML("beforeend", body);

// Mostrar reporte
detail.skipReportPage = true;
report.show(detail);
  });
}

export function fetchOne(detail, callback) {
  const phpFile = "server/php/sql/report.php";
  detail.inf = {
    entity: "customer",
    report: "account-all-profit-one",
    dbid: detail.dbid,
  };

  reportDB.select(detail, phpFile, (data) => {
    callback(data);
  });
}

export function fetchUnpaidInvoices(detail, callback) {
  const phpFile = "server/php/sql/report.php";
  detail.inf = {
    entity: "customer",
    report: "account-profit-period",
    id: detail.dbid,
  };

  reportDB.select(detail, phpFile, (data) => {
    callback(data);
  });
}

function generate(data) {

  var body = ''
  body += generateTop(data)
  body += generateTable(data)
  body += `</div> <!-- dataCont -->`
  body += `<div class="report-page">`

  return body
}

function generateTop(data) {

  let company_name = "";
  let current_dateTime = "";

  //if no data found
  if (data.length > 0) {
    company_name = data[0].company_name;
    current_dateTime = data[0].current_dateTime;
  } else {
    let config = settings.getData()
    company_name = config.company;
    current_dateTime = timeDate.getdateshort() + ' ' + timeTime.formatAMPM();
  }

  var table = `
    <div class="dataCont customerProfit-dataCont dn">
      <div ${css.title}>${company_name}</div>
      <div ${css.subtitle}>Customers Accounts Profits All Report As Of  ${current_dateTime}</div>
  `;

  return table

}/**/

function generateTable(data) {

  var totals = {
    total_last_month: 0,
    roi_last_month: '0%',
    total_last_6_months: 0,
    roi_last_6_months: '0%',
    total_last_year: 0,
    roi_last_year: '0%',
    total_earnings: 0,
    roi_total: '0%'
  };

  var table = `
    <h2 ${css.f15}>Customers Vs Profits Amounts: Financial report showing earnings and ROI per customer.</h2>
    <table ${css.table} class="dt-alterColor">
      <tr>
        <th ${css.th}>Customer</th>
        <th ${css.th}>Last Month</th>
        <th ${css.th}>Last 6 Months</th>
        <th ${css.th}>Last Year</th>
        <th ${css.th}>Total</th>
      </tr> 
  `;

  if (data.length == 0) {
    table += `
      <tr>
        <td ${css.td} colspan="5" align="center"><h3>No Profits Were Found.</h3></td>
      </tr>
    `;
    table += `</table>`;
    return table;
  }

  for (let i = 0; i < data.length; i++) {

    // ROI desde PHP; 999.99 en BD → mostrar +99.99% (ver math.percentFormat)
    let roi_last_month = math.percentFormat(data[i].roi_last_month ?? 0, 2);
    let roi_last_6_months = math.percentFormat(data[i].roi_last_6_months ?? 0, 2);
    let roi_last_year = math.percentFormat(data[i].roi_last_year ?? 0, 2);
    let roi_total = math.percentFormat(data[i].roi_total ?? 0, 2);

    // Acumular totales
    totals.total_last_month += parseFloat(data[i].total_last_month.replace(/[$,]/g, '')) || 0;
    totals.total_last_6_months += parseFloat(data[i].total_last_6_months.replace(/[$,]/g, '')) || 0;
    totals.total_last_year += parseFloat(data[i].total_last_year.replace(/[$,]/g, '')) || 0;
    totals.total_earnings += parseFloat(data[i].total_earnings.replace(/[$,]/g, '')) || 0;

    table += `
      <tr ${rowStyle(i)}>
        <td ${css.td}>${data[i].customer_name || data[i].provider_name}</td>
        <td ${css.td}>${data[i].total_last_month}<br><small>${roi_last_month}</small></td>
        <td ${css.td}>${data[i].total_last_6_months}<br><small>${roi_last_6_months}</small></td>
        <td ${css.td}>${data[i].total_last_year}<br><small>${roi_last_year}</small></td>
        <td ${css.td}>${data[i].total_earnings}<br><small>${roi_total}</small></td>
      </tr>
    `;
  }

  // Calcular ROI total acumulado (misma regla de tope que percentFormat)
  totals.roi_last_month = math.percentFormat(safePercentage(totals.total_last_month, totals.total_last_month), 2);
  totals.roi_last_6_months = math.percentFormat(safePercentage(totals.total_last_6_months, totals.total_last_6_months), 2);
  totals.roi_last_year = math.percentFormat(safePercentage(totals.total_last_year, totals.total_last_year), 2);
  totals.roi_total = math.percentFormat(safePercentage(totals.total_earnings, totals.total_earnings), 2);

  // Fila de totales
  table += `
    <tr ${rowStyle(data.length)}>
      <td ${css.totalLabel}>Total</td>
      <td ${css.td}>${cashVal(totals.total_last_month)}<br>${totals.roi_last_month}</td>
      <td ${css.td}>${cashVal(totals.total_last_6_months)}<br>${totals.roi_last_6_months}</td>
      <td ${css.td}>${cashVal(totals.total_last_year)}<br>${totals.roi_last_year}</td>
      <td ${css.td}>${cashVal(totals.total_earnings)}<br>${totals.roi_total}</td>
    </tr>
  `;

  table += `</table>`;
  return table;
}


function safePercentage(numerator, denominator) {
  if (!denominator || denominator === 0 || isNaN(denominator)) {
    return "0.00"; // Retorna un valor predeterminado si el denominador no es válido
  }

  if (!numerator || isNaN(numerator)) {
    numerator = 0; // Asegura que el numerador no sea `null` o `NaN`
  }

  return parseFloat((numerator / denominator) * 100).toFixed(2);
}

function cashVal(value) {
  return value.toLocaleString('en-US', { style: 'currency', currency: 'USD' });
}

function rowStyle(i) {

  if (i % 2 === 0) { return '' }
  return css.trGray

}